var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.grid)?_c(_vm.grid,_vm._g(_vm._b({tag:"component",attrs:{"errors":_vm.errors}},'component',_vm.$attrs,false),_vm.$listeners)):_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.$t('Resource not found')))])}
var staticRenderFns = []

export { render, staticRenderFns }